import { useState, useEffect } from 'react';
import L from 'leaflet';

export interface ZoomBounds {
  zoom?: number;
  bounds?: L.LatLngBounds;
}

export const useBoundsAndZoom = (map: L.Map | null | undefined) => {
  const [zoomBounds, setZoomBounds] = useState<ZoomBounds>({});
  if (map && !zoomBounds.bounds) {
    setZoomBounds({
      zoom: map.getZoom(),
      bounds: map.getBounds(),
    });
  }
  useEffect(() => {
    if (!map) return () => {};
    const listener = () => {
      setZoomBounds({
        bounds: map.getBounds(),
        zoom: map.getZoom(),
      });
    };
    map.addEventListener('zoomend moveend resize', listener);
    return () => map.removeEventListener('zoomend moveend resize', listener);
  }, [map]);
  return zoomBounds;
};
